import {
  Add,
  ApprovalSharp,
  CloseSharp,
  Delete,
  PreviewSharp,
  RequestQuoteSharp
} from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useState } from "react";
import InvoicePreview from "../Reports/InvoicePreview";

import { ShoppingCartContext } from "../Context/ShoppingCartContext";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import axios from "../../axiosInstances";

export default function ItemTransferModel(props) {
  const theme = useTheme();
  var fileObj = [];
  var fileArray = [];
  const [open, setOpen] = useState(false);
  const fullScreenValue = useMediaQuery(theme.breakpoints.down('md'));
  const { globalUser, allItems, globalToken, globalRoleSecurity } =
    useContext(ShoppingCartContext);
  const { t, i18n } = useTranslation();
  const [orderDate, setOrderDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [selectedVoucher, setSelectedVoucher] = useState("");
  const [transferlines, setTransferlines] = useState(props.ItemTransferLines);

  const [toStore, setToStore] = useState(props.TransferOrde ? props.TransferOrder.ToStore : props.data?.Store

  );
  const [fromStore, setFromStore] = useState(

  );
  const [StoresList, setStoresList] = useState(props.StoresList);
  const [transferOrder, setTransferOrder] = useState(
    props.TransferOrder ? props.TransferOrder : {
      Id: 0, OrderDate: orderDate, To: props?.data?.Store, Status: "Request",
      FromStoreName: (StoresList.filter(st => parseInt(st.Id) === parseInt(fromStore))[0]?.Name),
      ToStoreName: (StoresList.filter(st => parseInt(st.Id) === parseInt(toStore))[0]?.Name),
      RequestedByName: globalUser.Name
    }
  );

  const [lineItems, setLineItems] = useState(
    props.LineItems ? props.LineItems : allItems
  );
  const [EmployeesList, setEmployeesList] = useState(props.EmployeesList);



  const [issueTo, setIssuedTo] = useState(
    props.data ? props.data.Customer : ""
  );
  const [remark, setRemark] = useState(props.data ? props.data.Remark : "");

  const [productsList] = useState(allItems);

  const handleSubmit = (status, lItems, orderNo) => {
    if (
      fromStore === undefined ||
      fromStore === null ||
      fromStore.length <= 0
    ) {
      alert("First select store from");
      return;
    }
    if (toStore === undefined || toStore === null || toStore.length <= 0) {
      alert("First select store to");
      return;
    }
    if (fromStore === toStore) {
      alert("The source and destination stores must be difference");
      return;
    }

    if (
      lItems.filter((li) => li.Order === transferOrder.Id) === undefined ||
      lItems
        .filter((li) => (li.Order === undefined || li.Order === null || (li.Order === transferOrder.Id)))
        .filter((li) => li.Name.length > 0).length <= 0
    ) {
      alert("First select the items");
      return;
    }

    lItems
      .filter((li) => li.Order === transferOrder.Id)
      .map((li) => {
        if (isNaN(li.Quantity) || li.Quantity <= 0) {
          alert("First insert the proper quantity of product: " + li.Name);
          return;
        }
      });
    if (
      window.confirm(
        "Are you sure you want to save the transfer " + status + "?"
      )
    ) {
      try {
        var fd = new FormData();
        fd.append("Id", transferOrder.Id);

        fd.append("Order", transferOrder ? transferOrder.Order : props.data ? props.data?.OrderId : 0);
        fd.append(
          "From",
          StoresList.filter((st) => st.Name === fromStore)[0].Id
        );
        fd.append("To", StoresList.filter((st) => st.Name === toStore)[0].Id);
        fd.append(
          "RequestedBy",
          transferOrder.RequestedBy ? transferOrder.RequestedBy : globalUser.Id
        );
        fd.append(
          "RequestedDate",
          transferOrder.RequestedDate
            ? transferOrder.RequestedDate
            : format(new Date(), "yyyy-MM-dd")
        );
        fd.append(
          "ApprovedBy",
          transferOrder.ApprovedBy ? transferOrder.ApprovedBy : (status !== "Request" ? globalUser.Id : 0)
        );
        fd.append(
          "ApprovedDate",
          transferOrder.ApprovedDate
            ? transferOrder.ApprovedDate
            : (status !== "Request" ? format(new Date(), "yyyy-MM-dd") : '')
        );
        fd.append(
          "IssuedBy",
          transferOrder.IssuedBy ? transferOrder.IssuedBy : (status !== "Request" && status !== "Approved" ? globalUser.Id : 0)
        );
        fd.append(
          "IssuedDate",
          transferOrder.IssuedDate
            ? transferOrder.IssuedDate
            : (status !== "Request" && status !== "Approved" ? format(new Date(), "yyyy-MM-dd") : '')
        );
        fd.append(
          "ReceivedBy",
          transferOrder.ReceivedBy ? transferOrder.ReceivedBy : (status !== "Request" && status !== "Approved" ? globalUser.Id : 0)
        );
        fd.append(
          "ReceivedDate",
          transferOrder.ReceivedDate
            ? transferOrder.ReceivedDate
            : (status !== "Request" && status !== "Approved" ? format(new Date(), "yyyy-MM-dd") : '')
        );
        fd.append("Status", status);
        fd.append("Parent", globalUser.Parent);
        fd.append("Remark", transferOrder.Remark);
        fd.append("TransferLines", JSON.stringify(lItems));

        axios.post("/itemtransfers", fd, {
          headers: { "Content-Type": "application/json", token: globalToken },
        });
      } catch (err) {
      } finally {
        //setTransferlines([]);
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete?")) {
      try {
        axios.delete("/itemtransfers?Id=" + id, {
          headers: {
            token: globalToken,
          },
        }); //add id
      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };
  const handleLineItemDelete = (id) => {
    if (window.confirm("Are you sure you want to delete?")) {
      try {
        axios.delete("/lineitems?Id=" + id, {
          headers: {
            token: globalToken,
          },
        }); //add id
      } catch (err) {
      } finally {
      }
    }
  };
  useEffect(() => {
    setFromStore(transferOrder
      ? StoresList &&
        StoresList.filter(
          (st) => parseInt(st.Id) === parseInt(transferOrder.From)
        ).length > 0
        ? StoresList.filter(
          (st) => parseInt(st.Id) === parseInt(transferOrder.From)
        )[0].Name
        : ""
      : StoresList &&
        StoresList.filter(
          (st) => parseInt(st.Id) === parseInt(globalUser.Store)
        ).length > 0
        ? StoresList.filter(
          (st) => parseInt(st.Id) === parseInt(globalUser.Store)
        )[0].Name
        : ""
    );
    setToStore(transferOrder
      ? StoresList &&
        StoresList.filter(
          (st) => parseInt(st.Id) === parseInt(transferOrder.To)
        ).length > 0
        ? StoresList.filter(
          (st) => parseInt(st.Id) === parseInt(transferOrder.To)
        )[0].Name
        : ""
      : StoresList.filter(
        (st) => parseInt(st.Id) === parseInt(globalUser.Store)
      ).length > 0
        ? StoresList.filter(
          (st) => parseInt(st.Id) === parseInt(globalUser.Store)
        )[0].Name
        : ""
    )
  }
    , [transferOrder])

  return (
    <div>
      <label
        onClick={() => {
          setOpen(true);
        }}
      >
        {props.icon}
      </label>

      <Dialog
        maxWidth="md"
        /*      PaperProps={{
           sx: {
             height: '80vh',   // 80% of viewport height
             maxHeight: '90vh',
           },
         }} */
        PaperProps={{
          style: {
            borderRadius: 24,
            backgroundColor: '#fffcf9', // Warm off-white
            boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
          }
        }}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogContent>
          <DialogContentText mt={1}>
            <DialogTitle
              style={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
              }}
            >
              <Stack direction='row' style={{ flex: 1 }}>
                <Stack direction={fullScreenValue ? 'column' : 'row'} style={{ flex: 1 }}>

                  <div>{"From: " + fromStore}</div>
                  <div>{"  To: " + toStore}</div>
                </Stack>

                <IconButton style={{ backgroundColor: theme.palette.primary.light }} onClick={() => setOpen(false)} size="small"><CloseSharp /></IconButton>
              </Stack>
            </DialogTitle>
            <div>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  pl={"35%"}
                  sx={{
                    backgroundColor: theme.palette.primary.dark,
                    color: theme.palette.primary.contrastText,
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  {"Transfer " +
                    transferOrder?.Status}
                </Grid>
                <Grid item xs={12} md={6}>
                  <span>Doc. No.: {transferOrder.Id}</span>
                  <br></br>
                  <span>Status: {transferOrder.Status}</span>
                </Grid>

                <Grid item xs={12} md={4}>
                  Requested By:{" "}
                  {transferOrder.IssuedToName
                    ? transferOrder.RequestedByName
                      ? transferOrder.RequestedByName
                      : globalUser.Name
                    : globalUser.Name}
                </Grid>
                <Grid item xs={12} md={2}>
                  Date: {transferOrder.RequestedDate}

                </Grid>
                <Grid item xs={12} md={6} mt={1}>
                  <Autocomplete
                    label="From Store"
                    id="fromStore"
                    size="small"
                    variant="standard"
                    value={fromStore}
                    onChange={(e) => {
                      setFromStore(e.target.textContent);
                      transferOrder.FromStoreName = e.target.textContent;
                    }}
                    options={
                      (!(StoresList === undefined) &&
                        !(StoresList === null) &&
                        StoresList.length > 0) ?
                        StoresList.map((pro) => {
                          return pro.Name;
                        }) : ['']
                    }
                    sx={{ width: "95%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("From Store")}

                      //error={!from ? true : false}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  Approved By: {transferOrder.ApprovedByName}
                </Grid>
                <Grid item xs={2}>
                  Date: {transferOrder.ApprovedDate}

                </Grid>


                <Grid item xs={12} md={6} mt={1}>
                  <Autocomplete
                    label="To Store"
                    id="toStore"
                    size="small"
                    variant="standard"
                    value={toStore}
                    onChange={(e) => {
                      setToStore(e.target.textContent);
                      transferOrder.ToStoreName = e.target.textContent;
                    }}
                    options={
                      (!(StoresList === undefined) &&
                        !(StoresList === null) &&
                        StoresList.length > 0) ?
                        StoresList.map((pro) => {
                          return pro.Name;
                        }) : ['']
                    }
                    sx={{ width: "95%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("To Store")}

                      //error={!from ? true : false}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  Issued By: {transferOrder.IssuedByName}
                </Grid>
                <Grid item xs={12} md={2}>
                  Date: {transferOrder.IssuedDate}

                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    size="small"
                    variant="standard"
                    value={remark}
                    label="Remark"
                    minRows={2}
                    sx={{ width: "95%" }}
                    onChange={(e) => {
                      transferOrder.Remark = e.target.value;
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  Received By: {transferOrder.ReceivedByName}
                </Grid>
                <Grid item xs={12} md={2}>
                  Date: {transferOrder.ReceivedDate}

                </Grid>

                <Grid item xs={12}>
                  <Grid direction="row" container>
                    <hr></hr>
                    <Grid item xs={12} className="hideInMobile">
                      <Grid container>
                        <Grid
                          item
                          xs={1}
                          style={{
                            paddingLeft: "5px",
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                          }}
                        >
                          No.
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          style={{
                            paddingLeft: "5px",
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                          }}
                        >
                          {" "}
                          Item Name
                        </Grid>

                        <Grid
                          item
                          xs={2}
                          style={{
                            paddingLeft: "5px",
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                          }}
                        >
                          Quantity
                        </Grid>

                        <Grid
                          item
                          xs={4}
                          style={{
                            paddingLeft: "5px",
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            textAlign: "center",
                          }}
                        >
                          Remark
                        </Grid>
                        <Grid
                          item
                          xs={1}
                          style={{
                            paddingLeft: "5px",
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                          }}
                        >
                          <IconButton
                            size="small"
                            //id={transferOrder.Id}
                            onClick={(e) => {
                              if (
                                transferlines &&
                                transferlines.filter((itt) => itt.Item === "")
                                  .length <= 0
                              ) {
                                let newLineItem = {};
                                newLineItem.Item = "";
                                newLineItem.Name = "";
                                newLineItem.Order = transferOrder.Id;
                                //newLineItem.Job=transferOrder.Id;
                                //newLineItem.IssuedTo = transferOrder.IssuedTo;
                                newLineItem.Quantity = 0;
                                //newLineItem.IssuedToName = transferOrder.IssuedToName;
                                setTransferlines((xx) => [...xx, newLineItem]);
                              } else {
                                alert("First complete the data");
                              }

                            }}
                          >
                            <Add
                              sx={{ color: theme.palette.primary.contrastText }}
                            />
                          </IconButton>
                        </Grid>


                        {transferlines &&
                          transferlines !== null &&
                          transferlines.length > 0 &&
                          /*  transferlines.map(jl=>{
              var issuedQuantity=issuedQuantity + jl.Quantity;
            }) && */
                          transferlines
                            /*  .filter(
                               (it) =>
                                 parseInt(it.Order) ===
                                 parseInt(transferOrder.Id)
                             ) */
                            .map((item, index) => {
                              /*         
                  var issuedQuantity=item.Quantity; */
                              return (
                                <>
                                  <Grid item xs={12}>
                                    <hr></hr>
                                  </Grid>
                                  <Grid item xs={1} key={index}>
                                    {index + 1}
                                  </Grid>
                                  <Grid item xs={4}>
                                    <Autocomplete
                                      label="Items"
                                      id="Items"
                                      size="small"
                                      variant="standard"
                                      value={item.Name}
                                      onChange={(e) => {
                                        if (
                                          transferlines &&
                                          transferlines.length > 0 &&
                                          transferlines.filter(
                                            (li) =>
                                              li.Name === e.target.textContent
                                          ).length > 0
                                        ) {
                                          item.Item = "";
                                          item.Name = "";
                                          item.Quantity = 0;
                                          setTransferlines(
                                            transferlines.map((litem) => {
                                              return litem;
                                            })
                                          );
                                          //alert('The selected item is already registered')
                                          return;
                                        } else {
                                          let selectedProduct =
                                            productsList.filter(
                                              (selItem) =>
                                                selItem.Name ===
                                                e.target.textContent
                                            );

                                          if (
                                            selectedProduct &&
                                            selectedProduct.length > 0
                                          ) {
                                            item.Quantity =
                                              selectedProduct[0].Quantity;

                                            item.Item = selectedProduct[0].Item;
                                            item.Name = selectedProduct[0].Name;
                                            item.Order = transferOrder.Id;
                                            //item.IssuedTo=transferOrder.IssuedTo;
                                            //item.IssuedToName=transferOrder.IssuedToName;
                                            //item.Job=transferOrder.Id;
                                            setTransferlines((ji) => [
                                              ...ji,
                                              item,
                                            ]);
                                            setTransferlines(
                                              transferlines.map((litem) => {
                                                return litem;
                                              })
                                            );
                                          } else {
                                            item.Quantity = 0;
                                            //item.IssuedTo=transferOrder.IssuedTo;
                                            //item.IssuedToName=transferOrder.IssuedToName;
                                            item.Item = "";
                                            item.Name = "";

                                            setTransferlines(
                                              transferlines.map((litem) => {
                                                return litem;
                                              })
                                            );
                                          }
                                        }
                                      }}
                                      options={
                                        !(lineItems === undefined) &&
                                          !(lineItems === null) &&
                                          lineItems.length > 0
                                          ? lineItems.map((it) => {
                                            return it.Name;
                                          })
                                          : [""]
                                      }
                                      sx={{ width: "95%" }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={item.Name}

                                        //error={!from ? true : false}
                                        />
                                      )}
                                    />
                                  </Grid>

                                  <Grid item xs={2}>
                                    <TextField
                                      size="small"
                                      variant="standard"
                                      type="float"
                                      defaultValue={
                                        item.Quantity /* (lineItems && lineItems.filter(li=>li.Item===item.Item).length>0?lineItems.filter(li=>li.Item===item.Item)[0].Quantity:0)- issuedQuantity */
                                      }
                                      sx={{ width: "70px" }}
                                      onChange={(e) => {
                                        item.Quantity = e.target.value;
                                        setTransferlines(
                                          transferlines.map((litem) => {
                                            return litem;
                                          })
                                        );
                                      }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />
                                  </Grid>

                                  <Grid item xs={4}>
                                    <TextField
                                      size="small"
                                      variant="standard"
                                      value={item.Remark}
                                      sx={{ width: "95%" }}
                                      onChange={(e) => {
                                        item.Remark = e.target.value;
                                      }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />
                                  </Grid>
                                  <Grid item xs={1}>
                                    <Tooltip title="remove">
                                      <Button
                                        endIcon={<Delete width="10px" />}
                                        sx={{
                                          fontSize: "10px"
                                        }}
                                        onClick={() => {
                                          if (
                                            transferlines.filter(
                                              (litem) =>
                                                litem.Item === item.Item &&
                                                parseInt(litem.IssuedTo) ===
                                                parseInt(item.IssuedTo)
                                            ).Id
                                          ) {
                                            handleLineItemDelete(
                                              transferlines.filter(
                                                (litem) =>
                                                  litem.Item === item.Item &&
                                                  parseInt(litem.IssuedTo) ===
                                                  parseInt(item.IssuedTo)
                                              )[0].Id
                                            );
                                          }

                                          /*    setTransferlines(
                  transferlines.filter(
                    (litem) => !(litem.Item === item.Item && parseInt(litem.Supplier)===parseInt(item.Supplier))
                  )
                ); */
                                          if (
                                            transferlines /*. filter(
                                  (litem) =>                                                      
                                      parseInt(
                                        litem.IssuedTo
                                      ) ===
                                        parseInt(
                                          transferOrder.IssuedTo
                                        )                                                      
                                ) */.length <= 0
                                          ) {
                                            //setAssignedEmployees(EmployeesList.filter(ssp=>parseInt(ssp.Id)!==parseInt(sup.Id)));
                                            /* setOpen(false);
                                 let newLineItem = {};
                  newLineItem.Item = "";
                  newLineItem.Name = "";
                  newLineItem.Supplier = sup.Id;
                  newLineItem.UnitCost = 0;
                  newLineItem.Quantity = 0;
                  newLineItem.UnitPrice = 0;
                  newLineItem.TotalPrice = 0;
                  setTransferlines((xx) => [...xx, newLineItem]); */
                                          }
                                        }}
                                      ></Button>
                                    </Tooltip>
                                  </Grid>
                                </>
                              );
                            })}
                        <Grid item xs={12}>
                          <hr></hr>
                        </Grid>
                        <Grid item xs={5}></Grid>
                      </Grid>
                    </Grid>
                    <Grid item className="hideInFull" m={1} xs={12}>
                      {transferlines &&
                        transferlines !== null &&
                        transferlines.length > 0 &&
                        transferlines
                          /* .filter(
                (it) =>
                  parseInt(it.IssuedToName) === parseInt(transferOrder.IssuedToName)
              ) */
                          .map((item, index) => {
                            return (
                              <>
                                <Card
                                  sx={{
                                    borderRadius: 10,
                                    boxShadow: 3,
                                    width: "100%",
                                  }}
                                >
                                  <CardContent>
                                    <Grid container>
                                      <Grid item xs={4}>
                                        No.:
                                      </Grid>
                                      <Grid item xs={8} pl={0}>
                                        {index + 1}
                                      </Grid>
                                      <Grid item xs={4}>
                                        Product:
                                      </Grid>
                                      <Grid item xs={8} pl={0}>
                                        <Autocomplete
                                          label="Items"
                                          id="Items"
                                          size="small"
                                          variant="standard"
                                          value={item.Name}
                                          onChange={(e) => {
                                            if (
                                              transferlines.filter(
                                                (li) =>
                                                  li.Name ===
                                                  e.target.textContent
                                              ).length > 0
                                            ) {
                                              item.Item = "";
                                              item.Name = "";
                                              item.Quantity = 0;
                                              //item.IssuedTo = transferOrder.AssignTo;

                                              setTransferlines(
                                                transferlines.map((litem) => {
                                                  return litem;
                                                })
                                              );

                                              return;
                                            } else {
                                              let selectedProduct =
                                                productsList.filter(
                                                  (selItem) =>
                                                    selItem.Name ===
                                                    e.target.textContent
                                                );
                                              if (
                                                selectedProduct &&
                                                selectedProduct.length > 0
                                              ) {
                                                item.Quantity =
                                                  selectedProduct[0].DefaultOrderQty;

                                                item.Item =
                                                  selectedProduct[0].Item;
                                                item.Name =
                                                  selectedProduct[0].Name;
                                                //item.IssuedTo = transferOrder.AssignTo;

                                                setTransferlines(
                                                  transferlines.map((litem) => {
                                                    return litem;
                                                  })
                                                );
                                              } else {
                                                item.Quantity = 0;

                                                item.Item = "";
                                                item.Name = "";
                                                // item.IssuedTo = transferOrder.AssignTo;
                                                setTransferlines(
                                                  transferlines.map((litem) => {
                                                    return litem;
                                                  })
                                                );
                                              }
                                            }
                                          }}
                                          options={
                                            !(productsList === undefined) &&
                                              !(productsList === null) &&
                                              productsList.length > 0
                                              ? productsList.map((it) => {
                                                return it.Name;
                                              })
                                              : [""]
                                          }
                                          sx={{ width: "100%" }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label={item.Name}

                                            //error={!from ? true : false}
                                            />
                                          )}
                                        />
                                      </Grid>
                                      <Grid item xs={4}>
                                        Quantity:
                                      </Grid>
                                      <Grid item xs={8} pl={0}>
                                        <TextField
                                          size="small"
                                          variant="standard"
                                          type="float"
                                          value={item.Quantity}
                                          maxRows={4}
                                          sx={{ width: "100%" }}
                                          onChange={(e) => {
                                            item.Quantity = e.target.value;
                                            setTransferlines(
                                              transferlines.map((litem) => {
                                                return litem;
                                              })
                                            );
                                          }}
                                          InputLabelProps={{
                                            shrink: true,
                                          }}
                                        />
                                      </Grid>

                                      <Grid item xs={4}>
                                        Remark :
                                      </Grid>
                                      <Grid item xs={8} pl={8}>
                                        {item.Remark}
                                      </Grid>
                                      <Grid item xs={12}>
                                        <hr></hr>
                                        Remove: {"   "}
                                        <Tooltip title="remove">
                                          <Button
                                            endIcon={<Delete width="10px" />}
                                            sx={{
                                              fontSize: "10px"
                                            }}
                                            onClick={() => {
                                              handleLineItemDelete(
                                                transferlines.filter(
                                                  (litem) =>
                                                    litem.Item === item.Item
                                                )[0].Id
                                              );

                                              if (
                                                transferlines.filter(
                                                  (litem) =>
                                                    !(litem.Item === item.Item)
                                                ).length <= 0
                                              ) {
                                                let newLineItem = {};
                                                newLineItem.Item = "";
                                                newLineItem.Name = "";
                                                //newLineItem.IssuedTo = transferOrder.AssignTo;
                                                //newLineItem.IssuedToName = transferOrder.IssuedToName;
                                                newLineItem.Quantity = 0;

                                                setTransferlines((xx) => [
                                                  ...xx,
                                                  newLineItem,
                                                ]);
                                              }
                                            }}
                                          ></Button>
                                        </Tooltip>
                                      </Grid>
                                    </Grid>
                                  </CardContent>
                                </Card>
                                <hr></hr>
                              </>
                            );
                          })}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontSize: "8px",
            flexWrap: 'wrap',
          }}
        >
          <hr></hr>
          {props.TransferOrde &&
            <>
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<PreviewSharp />}
              >
                <InvoicePreview
                  icon={<div style={{ fontSize: "10px" }}>Preview</div>}
                  data={[transferOrder]}
                  LineItems={transferlines}
                  Type="TransferOrder"
                  DocumentType={"Transfer " + (transferOrder ? transferOrder.Status : "Request")}
                />
              </Button>
              |
            </>
          }
          {transferOrder === undefined || transferOrder === null || transferOrder?.Status !== "Direct" ? (
            <>
              {(
                transferOrder === undefined ||
                transferOrder === null) || (transferOrder && transferOrder.Status === "Request") &&
                globalRoleSecurity.filter(
                  (gs) =>
                    gs.Functionality === "Transfer Request" && gs.Security > 1
                ).length > 0 && (
                  <>
                    <Button
                      variant="standard"

                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<RequestQuoteSharp />}
                      autoFocus
                      onClick={() =>
                        handleSubmit(
                          "Request",
                          transferlines.filter(
                            (itt) => itt.Name && itt.Name.length > 0
                          ),
                          transferOrder.Id
                        )
                      }
                    >
                      Request
                    </Button>
                    |
                  </>
                )}
              {transferOrder &&
                (transferOrder.Status === "Request" ||
                  transferOrder.Status === "Approved") &&
                globalRoleSecurity.filter(
                  (gs) =>
                    gs.Functionality === "Transfer Approval" && gs.Security > 1
                ).length > 0 && (
                  <>
                    <Button
                      variant="standard"

                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<ApprovalSharp />}
                      autoFocus
                      onClick={() =>
                        handleSubmit(
                          "Approved",
                          transferlines.filter(
                            (itt) => itt.Name && itt.Name.length > 0
                          ),
                          transferOrder.Id
                        )
                      }
                    >
                      Approve
                    </Button>
                    |
                  </>
                )}
              {transferOrder &&
                globalRoleSecurity.filter(
                  (gs) =>
                    gs.Functionality === "Transfer " + transferOrder.Status &&
                    gs.Security > 2
                ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}

                      endIcon={<Delete />}
                      autoFocus
                      onClick={() => handleDelete(transferOrder.Id)}
                    >
                      Delete
                    </Button>
                    |
                  </>
                )}
            </>
          ) : (
            <>
              {globalRoleSecurity.filter(
                (gs) =>
                  gs.Functionality === "Transfer Direct" && gs.Security > 1
              ).length > 0 && (
                  <>
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<ApprovalSharp />}
                      autoFocus
                      onClick={() =>
                        handleSubmit(
                          "DI",
                          transferlines.filter(
                            (itt) => itt.Name && itt.Name.length > 0
                          ),
                          transferOrder.Id
                        )
                      }
                    >
                      Direct Issue
                    </Button>
                    |
                    <Button
                      variant="standard"
                      sx={{
                        borderRadius: 5,
                        fontSize: "10px",
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.light }
                      }}
                      endIcon={<ApprovalSharp />}
                      autoFocus
                      onClick={() =>
                        handleSubmit(
                          "DIR",
                          transferlines.filter(
                            (itt) => itt.Name && itt.Name.length > 0
                          ),
                          transferOrder.Id
                        )
                      }
                    >
                      Direct Issue and Receive
                    </Button>
                    |
                  </>
                )}
            </>
          )}
          <Button
            variant="standard"
            sx={{
              borderRadius: 5,
              fontSize: "10px",
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.light }
            }}
            endIcon={<CloseSharp />}

            onClick={() => setOpen(false)}
          >
            close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
